(() => {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const phone = window.matchMedia("(max-width: 900px)").matches;
  const boot = document.getElementById("Boot");
  const in505 = document.body.classList.contains("is-505");

  const sfx = (name) => {
    if (window.FH && typeof window.FH.playSfx === "function") window.FH.playSfx(name);
  };
  const startAmb = () => {
    if (window.FH && typeof window.FH.startAmb === "function") window.FH.startAmb();
  };

  if (boot && !reduced && !in505 && !sessionStorage.getItem("fh_tape")) {
    const closeBoot = (fromUser) => {
      if (boot.hidden || boot.classList.contains("is-out")) return;
      boot.classList.add("is-out");
      sessionStorage.setItem("fh_tape", "1");
      if (window.FH && typeof window.FH.enterHouse === "function") window.FH.enterHouse();
      if (!phone || fromUser) sfx("load");
      startAmb();
      setTimeout(() => { boot.hidden = true; }, 340);
    };
    const preP = phone ? null : (window.FH && typeof window.FH.playSfx === "function" ? window.FH.playSfx("pre") : null);
    boot.querySelector("[data-boot-skip]")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeBoot(true);
    });
    if (preP && typeof preP.then === "function") preP.then(() => closeBoot(false));
    setTimeout(() => closeBoot(false), phone ? 2600 : 4500);
  } else if (boot) {
    boot.hidden = true;
    if (!in505) {
      if (window.FH && typeof window.FH.enterHouse === "function") window.FH.enterHouse();
      startAmb();
    }
  }

  const clocks = document.querySelectorAll("[data-clock]");
  if (clocks.length) {
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      const d = new Date();
      const text = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      clocks.forEach((el) => { el.textContent = text; });
    };
    tick();
    setInterval(tick, 1000);
  }

  window.playVideo = (id) => {
    const pop = document.getElementById("videoPopup");
    const frame = document.getElementById("videoIframe");
    if (!pop || !frame) return;
    frame.src = "https://www.youtube.com/embed/" + id + "?autoplay=1";
    pop.classList.add("is-open");
    pop.style.display = "grid";
  };
  window.closeVideo = () => {
    const pop = document.getElementById("videoPopup");
    const frame = document.getElementById("videoIframe");
    if (frame) frame.src = "";
    pop?.classList.remove("is-open");
    if (pop) pop.style.display = "none";
  };
})();
